.caption {
  width: 100%;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Header favorite: a grey star in both states (the fill carries the state, not colour) */
.favoriteIcon {
  color: var(--tuna-palette-text-secondary);
}
